export default __webpack_public_path__ + "static/media/8 senali.22e1a0a5.jpg";